var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.72396 9.97315C3.94262 9.97315 4.11276 9.87796 4.23623 9.68991L9.86902 0.855121C9.96654 0.703921 10 0.587984 10 0.472032C10 0.192176 9.813 0 9.52795 0C9.32487 0 9.20946 0.0692486 9.08832 0.264812L3.70088 8.79644L0.937086 5.2624C0.808429 5.08758 0.682637 5.01314 0.492787 5.01314C0.205416 5.01314 0 5.21337 0 5.49842C0 5.61902 0.0513515 5.75 0.151212 5.8758L3.18915 9.67954C3.3484 9.88262 3.50299 9.97315 3.72396 9.97315Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.133f0cc8ca5aab20c9e261aa0046f521.svg";
export { ForwardRef as ReactComponent };